import { getStage } from "./context";

export const showContractAddendum = getStage() !== "prod";
